import { Button, Card, Input, Modal, Popover, Select, Tag, Typography, Upload, message } from "antd";
import { useContext, useEffect, useState } from "react";
import { statusList } from "../../../utils";
import { EditOutlined, UploadOutlined } from "@ant-design/icons";
import { doc, updateDoc } from 'firebase/firestore';
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { Gallery } from "../../Orders/Gallery";
import { OrdersContext } from "../../../context/OrdersContext";



const { Option } = Select;


export const OrderCard = ({db, record }) => {
    const [editingThisCard, setEditingThisCard] = useState(false);
    const [currentStatus, setCurrentStatus] = useState(record.status);
    const [currentPaymentType, setCurrentPaymentType] = useState("");
    const [currentPaymentCode, setCurrentPaymentCode] = useState("");
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [uploadedImages, setUploadedImages] = useState([]);
    const [receipts, setReceipts] = useState(record.orderImage || []);
    const [openReceipt, setOpenReceipt] = useState(false);
    
    const { 
      refetch,
    } = useContext(OrdersContext);
    
    const [, setEditingKey] = useState("");

    const cancel = () => setEditingKey("");
    const save = () => cancel();

    const handleStatusChange = (value) => setCurrentStatus(value);
    const handlePaymentTypeChange = (value) => setCurrentPaymentType(value);

    const startEditingThisCard = () => {
      setEditingKey(record.key);
      setEditingThisCard(true);
    };
  
  const saveChanges = async () => {
    await updateOrderInFirebase();
    if (uploadedImages.length > 0) {
      try {
        const orderRef = doc(db, 'orders', record.key);
        await updateDoc(orderRef, {
          orderImage: uploadedImages
      });
        message.success(`Imagenes subidas con exito`);
        refetch()
      } catch (error) {
        message.error("Error al actualizar las URLs de las imágenes: ", error);
      }
    }

    save(record.key);
    setEditingThisCard(false);
    };

    const cancelChanges = () => {
      cancel();
      setEditingThisCard(false);
    };

    const showProductsModal = () => {
      setIsModalVisible(true);
    };

    const handleModalClose = () => {
      setIsModalVisible(false);
    };

    const uploadFile = async (file, onSuccess, onError) => {
      try {
        const storage = getStorage();
        const fileRef = ref(storage, 'order-images/' + file.name);
        await uploadBytes(fileRef, file);
    
        const downloadUrl = await getDownloadURL(fileRef);
        setUploadedImages((prevImages) => [...prevImages, downloadUrl]);
        onSuccess();
      } catch (error) {
        console.error("Error subiendo el archivo:", error);
        onError(error);
      }
    };

    const updateOrderInFirebase = async () => {
      try {
        const orderRef = doc(db, 'orders', record.key);
        await updateDoc(orderRef, {
          status: currentStatus ? currentStatus : "En ruta",
          paymentType: currentPaymentType ? currentPaymentType : "Sin tipo de pago",
          paymentCode: currentPaymentCode ? currentPaymentCode : "Sin codigo de pago"
        });
        message.success(`Datos del pedido actualizados correctamente`);
        refetch();
      } catch (error) {
        message.error("Error al actualizar los datos del pedido: ", error);
      }
    };    
    
    
    useEffect(() => {
      setReceipts(record.orderImage || []);
  }, [record.orderImage]);

  const content = (
    <div>
      <Typography.Text >{record.address}</Typography.Text>
    </div>
  );
    

    return (
      <>
      <Card className="mb-5 w-full">
      <div className="flex justify-between items-center mb-2">
        <Typography.Text className="font-bold">{record.customerName}</Typography.Text>
      </div>
      <div className="flex justify-between items-center mb-2">
        <Typography.Text >Teléfono:</Typography.Text>
        <Typography.Text>{record.phoneNumber}</Typography.Text>
      </div>
      <div className="flex justify-between items-center mb-2">
        <Typography.Text >Dirección:</Typography.Text>
        <Popover content={content} title="Dirección">
          <Typography.Text className="text-right w-[250px] truncate">{record.address}</Typography.Text>
        </Popover>
      </div>
      <div className="flex justify-between items-center mb-2">
        <Typography.Text >Referencia:</Typography.Text>
        <Typography.Text className="text-right w-[250px] truncate">{record.reference ? record.reference : "Sin referencia"}</Typography.Text>
      </div>
      <div className="flex justify-between items-center mb-2">
        <Typography.Text >Productos:</Typography.Text>
        <Button type="link" onClick={showProductsModal}>Ver {record.products.length} producto(s)</Button>
      </div>
      {editingThisCard ? (
        <div className="flex justify-between items-center mb-2">
          <Typography.Text>Codigo de pago:</Typography.Text>
          <Input 
            className="w-32"
            value={currentPaymentCode}
            onChange={(e) => setCurrentPaymentCode(e.target.value)}
            placeholder="Ingresa código de pago"
          />
        </div>
      ) : (
        <div className="flex justify-between items-center mb-2">
          <Typography.Text>Codigo de pago:</Typography.Text>
          <Typography.Text>{record.paymentCode ? record.paymentCode : "Sin codigo de pago"}</Typography.Text>
        </div>
      )}

      {
          editingThisCard ? (
            <div className="flex justify-between items-center mb-2">
              <Typography.Text>Tipo de Pago:</Typography.Text>
              <Select className="w-32" value={currentPaymentType} placeholder="Selecciona un tipo de pago" onChange={handlePaymentTypeChange}>
                <Option value="Yape">Yape</Option>
                <Option value="Plin">Plin</Option>
                <Option value="Efectivo">Efectivo</Option>
                <Option value="POS">POS</Option>
                <Option value="Transferencia">Transferencia</Option>
              </Select>
            </div>
          ) : (
            <div className="flex justify-between items-center mb-2">
              <Typography.Text>Tipo de Pago:</Typography.Text>
              <Typography.Text>{record.paymentType ? record.paymentType : "Sin tipo de pago"}</Typography.Text>
            </div>
          )
        }
        <div className="flex justify-between items-center mb-2">
          <Typography.Text>Pago pendiente:</Typography.Text>
          <Typography.Text>${record.payable ? record.payable.toFixed(2) : '0.00'}</Typography.Text>
        </div>
        {editingThisCard ? (
          <div className="flex justify-between items-center mb-2">
            <Typography.Text>Estado:</Typography.Text>
            <Select value={currentStatus} onChange={handleStatusChange}>
              <Option value="Entregado">Entregado</Option>
            </Select>
          </div>
        ) : (
          <div className="flex justify-between items-center mb-2">
            <Typography.Text>Estado:</Typography.Text>
            <Tag color={statusList[record.status].color}>{record.status}</Tag>
          </div>
        )}
        {editingThisCard ? (
          <>
            {record.orderImage && record.orderImage.length > 0 ? (
              <div className="flex justify-between items-center mb-2">
                <Typography.Text >Imagen pedido:</Typography.Text>
                <Button type="link" onClick={() => {}}>Visualizar imagen</Button>
              </div>
            ) : (
              <div className="flex justify-between items-center mb-2">
                <Typography.Text >Imagen pedido:</Typography.Text>
                <Upload
                  accept=".png,.jpg,.jpeg"
                  multiple={true}
                  showUploadList={false}
                  onChange={(info) => {
                      if (info.file.status === "uploading" && !info.fileList.some(file => file.status === "uploading")) {
                          message.loading('Cargando imágenes...', 0);
                      }
                      if (info.file.status === "done") {
                          message.success(`${info.file.name} fue subido exitosamente`);
                      } else if (info.file.status === "error") {
                          message.error(`${info.file.name} no pudo subirse.`);
                      }

                      if (!info.fileList.some(file => file.status === "uploading")) {
                          message.destroy();
                      }
                  }}
                  customRequest={async ({ file, onSuccess, onError }) => {
                    await uploadFile(file, onSuccess, onError);
                  }}
                >
                  <Button icon={<UploadOutlined />}>Subir</Button>
                </Upload>
              </div>
            )}
            <div className="flex justify-end items-center">
              <Button onClick={saveChanges}>Guardar</Button>
              <Button onClick={cancelChanges} className="ml-2">Cancelar</Button>
            </div>
          </>
        ) : (
          <>
            {record.orderImage && record.orderImage.length > 0 ? (
              <div className="flex justify-between items-center mb-2">
                  <Typography.Text>Imagen pedido:</Typography.Text>
                  <Button type="link" onClick={() => setOpenReceipt(true)}>
                      Ver imágenes
                  </Button>
              </div>
                ) : (
                    <div className="flex justify-between items-center mb-2">
                        <Typography.Text>Imagen pedido:</Typography.Text>
                        <Typography.Text>Sin imagen de pedido</Typography.Text>
                    </div>
                )}
            <div className="flex justify-end">
              <Button type="text" icon={<EditOutlined />} onClick={startEditingThisCard} className="bg-transparent border-none"></Button>
            </div>
          </>
        )}
      </Card>
      <Modal
      title="Productos"
      open={isModalVisible}
      onCancel={handleModalClose}
      footer={[
        <Button key="close" onClick={handleModalClose}>
          Cerrar
        </Button>
      ]}
    >
      {record.products.map((product, idx) => (
        <div className="mb-2" key={idx}>
          <div className="flex justify-between items-center mb-2">
            <Typography.Text >Marca:</Typography.Text>
            <Typography.Text>{product.brand}</Typography.Text>
          </div>
          <div className="flex justify-between items-center mb-2">
            <Typography.Text >Categoria:</Typography.Text>
            <Typography.Text>{product.category}</Typography.Text>
          </div>
          <div className="flex justify-between items-center mb-2">
            <Typography.Text >Color:</Typography.Text>
            <Typography.Text>{product.color}</Typography.Text>
          </div>
          <div className="flex justify-between items-center mb-2">
            <Typography.Text >Modelo:</Typography.Text>
            <Typography.Text>{product.model}</Typography.Text>
          </div>
          <div className="flex justify-between items-center mb-2">
            <Typography.Text >Observaciones:</Typography.Text>
            <Typography.Text>{product.observation}</Typography.Text>
          </div>
          <div className="flex justify-between items-center mb-2">
            <Typography.Text >Cantidad:</Typography.Text>
            <Typography.Text>{product.quantity}</Typography.Text>
          </div>
          <div className="flex justify-between items-center mb-2">
            <Typography.Text >Talla:</Typography.Text>
            <Typography.Text>{product.size}</Typography.Text>
          </div>
          <div className="flex justify-between items-center mb-2">
            <Typography.Text >Total:</Typography.Text>
            <Typography.Text>${product.total ? product.total.toFixed(2) : '0.00'}</Typography.Text>
          </div>
          <div className="flex justify-center items-center mb-2">
          ------------------------------------------
          </div>
        </div>
      ))}
    </Modal>
    <Gallery
      images={receipts}
      isModalOpen={openReceipt}
      setIsModalOpen={setOpenReceipt}
    />
    </>
    );
  };